// src/pages/home/home.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./home.css";
import HomePageSlider from '../../component/homePageSlider/HomePageSlider';
import HomePageObject1 from '../../component/homePageObject1/homePageObject1';
import HomePageObject2 from '../../component/homePageObject2/homePageObject2';
import Faq from '../../component/faq/Faq';
import Pricing from '../../component/pricing/Pricing';
import PreviewModal from '../../component/navbar/PreviewModal';


const Home = () => {

  return (
    <div>
      <HomePageSlider />
      <HomePageObject1 />
      <HomePageObject2 />
      <Pricing />
      
      {/* <Faq /> */}
      
    </div>
  );
};

export default Home;
